import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const NavContainer = styled.div<{ inverse: boolean }>(({ inverse }) => `
  background-color: #f3eee2;
  padding: 0 32px;
  border-bottom: 1px solid #635E5B;
  z-index:9999

  @media (min-width: 1080px) {
    padding: 0 64px;
  }

  ${inverse && `
    filter: invert(100%);
    background-color: transparent;
  `}
`);

export interface DesktopNavBarProps {
  disableInverse?: boolean;
}

export const DesktopNavBar: React.FC<DesktopNavBarProps> = ({ children, disableInverse }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const inverse = !disableInverse && scrollPosition < 40;

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  function handleScroll() {
    setScrollPosition(window.scrollY);
  }

  function toggleSidebar() {
    setSidebarOpen(!sidebarOpen);
  }

  return (
    <NavContainer
      inverse={inverse}
      className="fixed z-10 flex items-center justify-between w-full h-20 text-black"
    >
      {children}
    </NavContainer>
  );
};
